/**
 * Normaliza respuestas de tokens push: el backend puede envolver el array
 * de formas distintas (Laravel resource, paginación, snake_case, etc.).
 */

export function extractPushTokensArray(apiBody) {
  if (apiBody == null) return []
  if (Array.isArray(apiBody)) return apiBody
  if (Array.isArray(apiBody.data)) return apiBody.data
  if (apiBody.data && Array.isArray(apiBody.data.data)) return apiBody.data.data
  if (Array.isArray(apiBody.tokens)) return apiBody.tokens
  if (apiBody.data && Array.isArray(apiBody.data.tokens)) return apiBody.data.tokens
  if (apiBody.data && typeof apiBody.data === 'object' && !Array.isArray(apiBody.data)) {
    const d = apiBody.data
    if (Array.isArray(d.items)) return d.items
    if (Array.isArray(d.records)) return d.records
  }
  return []
}

/**
 * Considera activo un registro de token (boolean, 0/1, string, o ausente si el API solo devuelve activos).
 */
export function isPushTokenActive(item) {
  if (item == null || typeof item !== 'object') return false
  const a = item.activo ?? item.active ?? item.activa
  if (a === false || a === 0 || a === '0' || String(a).toLowerCase() === 'false') return false
  if (a === true || a === 1 || a === '1' || String(a).toLowerCase() === 'true') return true
  if (item.estado != null) {
    const e = String(item.estado).toUpperCase()
    if (e.includes('INACTIV') || e === 'BAJA' || e === 'DESACTIV') return false
    if (e.includes('ACTIV')) return true
  }
  // Muchos APIs solo listan tokens vigentes sin campo "activo"
  return true
}
